import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gay6r22jg: FaireProductEntity = {
  token: "p_5gay6r22jg",
  type: "product",
  name: "Calm Essential Oil Roller | Natural Essential Oil Roller",
  brandName: "Soulistic Root - Essential Oils & Self Care Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/5a9ee686b2b9439bc211e59cbad47114587d5d190129e3483e416dcc0f31fd5a.png",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8bf8762345387bfdf97ace4eb5bd1961513d7c88fea8feac655932ee8ce23658.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
